import t from "./_getMapData.js";
function e(a) {
  return t(this, a).has(a);
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_mapCacheHas.js
// module id = 1536
// module chunks = 67